export const ACCOUNTS_CAMPAIGNS_SELECTOR_LIST_TYPE = {
  AVAILABLE: 'available',
  SELECTED: 'selected',
};
